import { Link } from "react-router-dom";
import { useSeo } from "../lib/ui";
import { EcosystemFramework } from "../components/Ecosystem";

/** The framework on its own page, for anyone who needs the whole industry set out at once. */
export default function EcosystemPage() {
  useSeo({
    title: "The Football Ecosystem — KickStartKenyaFootball",
    description:
      "A football industry is not fifteen talented children. It is fifteen professions — players, coaches, referees, scouts, administrators, club management, medical and fitness, media, agents, facilities, professional clubs, education, sponsorship, investment and governance — and our Plan addresses this problem.",
  });

  return (
    <div className="bg-black pb-10 pt-12 md:pt-16" data-testid="ecosystem-page">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <p className="overline text-ochre">The framework</p>
        <h1 className="display-1 mt-5 max-w-4xl">Fifteen Parts Of A Football Industry</h1>
        <p className="body-copy mt-6 max-w-3xl">
          KickStartKenyaFootball is not a campaign to find talented children. Finding them is the easy part.
          What Kenya is short of is the industry around them: the people, the institutions, the buildings, the
          qualifications and the capital that turn a gifted fifteen-year-old into a professional career and a
          hundred other people&rsquo;s jobs. This is the whole of it, and every part is covered somewhere on
          this platform.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/plans" className="btn-primary" data-testid="ecosystem-plan-cta">
            See the national plan
          </Link>
          <Link to="/counties" className="btn-ghost" data-testid="ecosystem-counties-cta">
            Explore your county
          </Link>
        </div>
      </div>
      <EcosystemFramework />
    </div>
  );
}
